import React, { useState, useRef, useEffect, useCallback } from 'react';

import { withEventScope } from '@repo/event-processor';
import { Modal } from '@repo/ui/deprecated/Modal';

import { DesignPostData } from 'global/types/DesignPostData';
import useWindowSize from 'global/utils/useWindowSize';
import { FlexColumn } from 'styles/layouts';

import DesignPost from '../DesignPost';
import RelatedDesigns from '../RelatedDesigns/RelatedDesigns';

import { RelatedDesignsWrapper } from './styles';
import { DesignPostModalProps } from './types';

const DesignPostModal: React.FC<DesignPostModalProps> = (props) => {
  const [post, setPost] = useState(props.post);
  const modalRef = useRef<HTMLDivElement>(null);
  const { isTabletMin, isLaptopMin } = useWindowSize();

  useEffect(() => {
    if (props.post) {
      setPost(props.post);
    }
  }, [props.post]);

  const handleRelatedDesignClick = (relatedPost: DesignPostData): void => {
    if (relatedPost) {
      setPost(relatedPost);
      requestAnimationFrame(() => {
        modalRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  };

  const getPadding = useCallback((): string => {
    if (isTabletMin) {
      return '55px 0px 0 0';
    }

    if (isLaptopMin) {
      return '55px 24px';
    }

    return '55px 32px';
  }, [isLaptopMin, isTabletMin]);

  return (
    <Modal
      consistentVerticalScrollbar
      externalCloseButton
      isOpen={!!props.post}
      theme={{ padding: getPadding() }}
      width="1116px"
      onClose={props.onClose}
    >
      {post && (
        <FlexColumn width="100%">
          <DesignPost
            currentSubUseCase={props.currentSubUseCase}
            currentUseCase={props.currentUseCase}
            fromAuthorPage={
              !!props.fromAuthorSlug &&
              props.fromAuthorSlug === post.template?.createdBy?.slug
            }
            modalRef={modalRef}
            post={post}
            onClose={props.onClose}
          />
          <RelatedDesignsWrapper>
            <RelatedDesigns
              postId={post.id}
              onClickDesign={handleRelatedDesignClick}
            />
          </RelatedDesignsWrapper>
        </FlexColumn>
      )}
    </Modal>
  );
};

export default withEventScope(DesignPostModal, { feature: 'designPostModal' });
